import * as React from 'react';

export const MasteryLevel2SVG = () => (
  <svg width="38" height="44" viewBox="0 0 38 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M33.4545 13.6547L19 5.3094L4.54552 13.6547V30.3453L19 38.6906L33.4545 30.3453V13.6547Z"
      fill="#FFF4E8"
      stroke="#FAAF00"
      strokeWidth="4"
    />
    <path
      d="M14.7706 29V27.66C15.9573 26.5133 16.9773 25.4933 17.8306 24.6C18.6973 23.6933 19.3639 22.8733 19.8306 22.14C20.2973 21.3933 20.5306 20.7 20.5306 20.06C20.5306 19.3933 20.3506 18.86 19.9906 18.46C19.6306 18.06 19.1106 17.86 18.4306 17.86C17.9373 17.86 17.4839 18 17.0706 18.28C16.6706 18.56 16.2973 18.8933 15.9506 19.28L14.6706 18C15.2573 17.3733 15.8639 16.8933 16.4906 16.56C17.1173 16.2133 17.8639 16.04 18.7306 16.04C19.9573 16.04 20.9306 16.3933 21.6506 17.1C22.3839 17.8067 22.7506 18.7533 22.7506 19.94C22.7506 20.6867 22.5373 21.4533 22.1106 22.24C21.6973 23.0133 21.1373 23.8067 20.4306 24.62C19.7373 25.4333 18.9706 26.2867 18.1306 27.18C18.4639 27.1533 18.8239 27.1267 19.2106 27.1C19.5973 27.06 19.9439 27.04 20.2506 27.04H23.3706V29H14.7706Z"
      fill="black"
    />
  </svg>
);
